import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { initializeMsal } from '@/services/msalAuth';
import './styles/global.css';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000,
			gcTime: 10 * 60 * 1000,
			refetchOnWindowFocus: false,
			refetchOnReconnect: false,
			retry: 1,
		},
		mutations: {
			retry: 0,
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById('root')!);

const renderApp = () => {
	root.render(
		<QueryClientProvider client={queryClient}>
			<App />
		</QueryClientProvider>,
	);
};

void initializeMsal()
	.catch(() => null)
	.finally(() => {
		renderApp();
	});
